import { DialogContent, DialogContentText, useTheme, useMediaQuery } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { ReactElement } from 'react';
import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

interface ServiceOperatorModalProps {
  open: boolean;
  onClose: (open?: boolean) => void;
  onYes: (open?: boolean) => void;
  onNo: (open?: boolean) => void;
  children: ReactElement;
  disabled?: boolean;
}

const ServiceOperatorModal = ({
  open,
  onClose,
  onYes,
  onNo,
  children,
  disabled,
}: ServiceOperatorModalProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return open ? (
    <PmiDialog
      open={open}
      fullScreen={fullScreen}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrand" color="white">
        Attenzione
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <DialogContentText id="alert-dialog-description" color="grey">
          Ci sono operatori collegati al servizio selezionato.
        </DialogContentText>
        <DialogContentText id="dialog-description" color="grey">
          Scegliere un servizio da associargli.
        </DialogContentText>
        <div className="pmi-py-4">{children}</div>
      </DialogContent>
      <div className="pmi-d-flex pmi-justify-content-end pmi-pb-3 pmi-px-3">
        <div className="pmi-mr-3 pmi-pr-1 pmi-w-25">
          <PmiButton
            fullWidth
            onClick={() => onYes(false)}
            variant="contained"
            color="primary"
            disabled={disabled}
          >
            Conferma
          </PmiButton>
        </div>
        <div className="pmi-w-25">
          <PmiButton fullWidth onClick={() => onNo(false)} variant="outlined" color="cdmBrand">
            Annulla
          </PmiButton>
        </div>
      </div>
    </PmiDialog>
  ) : (
    <></>
  );
};

ServiceOperatorModal.displayName = 'Service Operator Modal component';

export default ServiceOperatorModal;
